import { DialogTrigger, Dialog, Modal } from 'react-aria-components';
import { SubmitHandler, useForm } from 'react-hook-form';

import { useAtom } from 'jotai';
import InputText from 'src/components/InputText/InputText';

import { updatePerformanceRecordStatus } from '@/api/updatePerformanceRecordStatus';
import Button from '@/components/Button/Button';
import { NotificationAtom } from '@/jotai/jotai';
import { PerformanceRecordStatusRequest } from '@/types/performanceRecord';

type Props = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  afterSubmit: () => void;
  childID: number;
  performanceRecordID: number;
  lineAccessToken: string;
  status: 'approved' | 'rejected';
  target: string;
};

export const UpdateDialog = ({
  isOpen,
  setIsOpen,
  afterSubmit,
  childID,
  performanceRecordID,
  lineAccessToken,
  status,
  target,
}: Props) => {
  const [_, setNotification] = useAtom(NotificationAtom);

  const { register, handleSubmit } = useForm<PerformanceRecordStatusRequest>({});

  const onSubmit: SubmitHandler<PerformanceRecordStatusRequest> = async (data) => {
    try {
      console.log('updte performance record status', {
        childID,
        performanceRecordID,
        lineAccessToken,
        status,
        rejection_reason: data.rejection_reason,
      });
      const result = await updatePerformanceRecordStatus(
        childID,
        performanceRecordID,
        lineAccessToken,
        {
          status: status,
          rejection_reason: data.rejection_reason,
        }
      );
      console.log(result);
      if (result.status === 201) {
        console.log(result.result);
        setNotification({
          headingLevel: 'h2',
          type: 'success',
          bannerStyle: 'standard',
          title: '実績記録票を更新しました',
          message: '実績記録票を更新しました',
        });
      } else {
        setNotification({
          headingLevel: 'h2',
          type: 'error',
          bannerStyle: 'standard',
          title: '実績記録票の更新に失敗しました',
          message: '実績記録票の更新に失敗しました',
        });
      }
    } catch (error) {
      setNotification({
        headingLevel: 'h2',
        type: 'error',
        bannerStyle: 'standard',
        title: '実績記録票の更新に失敗しました',
        message: '実績記録票の更新に失敗しました',
      });
    }

    setIsOpen(false);
    afterSubmit();
  };

  return (
    <DialogTrigger
      isOpen={isOpen}
      onOpenChange={() => setIsOpen(false)}
    >
      <Modal className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
        <Dialog className="w-[600px] rounded-lg border border-gray-400 bg-white p-6 shadow-lg outline-none">
          <div className="flex flex-row justify-between">
            <h1 className="mb-5 text-2xl font-700">{`実績記録票の${status === 'approved' ? '承認' : '差戻し'}`}</h1>
          </div>

          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="flex flex-row gap-4">
              <span>{`${target}の実績記録票を${status === 'approved' ? '承認' : '差戻し'}しますがよろしいですか？`}</span>
            </div>
            {status === 'rejected' && (
              <div className="mt-4">
                <InputText
                  type="text"
                  required
                  label="差戻し理由"
                  {...register('rejection_reason', { required: true })}
                />
              </div>
            )}
            <div className="mt-10 flex flex-row items-center justify-center space-x-2">
              <Button
                type="button"
                size="lg"
                variant="outline"
                onClick={() => setIsOpen(false)}
              >
                戻る
              </Button>
              <Button
                variant="solid-fill"
                size="lg"
                type="submit"
              >
                {status === 'approved' ? '承認する' : '差戻しする'}
              </Button>
            </div>
          </form>
        </Dialog>
      </Modal>
    </DialogTrigger>
  );
};
